import Department from './Department';
import moment from 'moment';

export default class DepartmentMemberRelation {
    static fromData(data) {
        if (!data) {
            return;
        }

        const memberRelation = new DepartmentMemberRelation();
        memberRelation.id = data.id;
        memberRelation.department = Department.fromData(data.department);
        memberRelation.start = moment(data.start, 'DD.MM.YYYY');
        memberRelation.end = data.end !== null ? moment(data.end, 'DD.MM.YYYY') : null;
        memberRelation.isDepartmentViewable = data.isDepartmentViewable;

        Object.seal(memberRelation);
        return memberRelation;
    }

    toData() {
        return {
            id: this.id,
            department: this.department,
            start: this.start.format('DD.MM.YYYY'),
            end: this.end === null ? null : this.end.format('DD.MM.YYYY'),
        };
    }

    isEmpty() {
        return !this.start && !this.end && !this.department;
    }

    isValid() {
        if (!this.department) {
            return false;
        }

        if (!this.start) {
            return false;
        }

        if (this.end && moment(this.start, 'DD.MM.YYYY') > moment(this.end, 'DD.MM.YYYY')) {
            return false;
        }

        return true;
    }

    formattedEnd() {
        return this.end === null ? null : this.end.format('DD.MM.YYYY');
    }
}
